export default "__VITE_ASSET__DoS8v6T9__"